"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printPrivacyPolicy = exports.printIframes = exports.printCheckBoxs = exports.phoneProps = exports._envioSE = exports._envioBI = exports._createSondaContext = exports._CMNTimeTableValid = exports.TIPOS_ENCAMINAMIENTO = exports.TESVALUES = exports.MODAL_CONTENT = exports.MODALS_TYPES = exports.EMPLEADOS = exports.DESTINO_FORM = exports.DESTINO = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdFormskeleton = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.checkbox"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Variable con los posibles valores del campo empleados
 */
const EMPLEADOS = [{
  value: '2',
  label: 'Hasta 2'
}, {
  value: '10',
  label: '3 o más'
}];
/**
 * Variable con los posibles valores de modales
 */

exports.EMPLEADOS = EMPLEADOS;
const MODALS_TYPES = {
  C2C: 'c2c',
  CALLNOTSTABLISHED: 'callNotStablished',
  CALLPENDING: 'callPending',
  REQUESTPENDING: 'requestPending',
  CMLPENDING: 'cmlPending',
  INVALIDFORM: 'invalidForm'
};
/**
 * Variable con los posibles valores de los destinos del formulario
 */

exports.MODALS_TYPES = MODALS_TYPES;
const DESTINO_FORM = {
  AVATAR: 'AvatarPlus C2C',
  INSIDESALES: 'Inside Sales C2C',
  GEVICO: 'Gevico C2C',
  FONDOS: 'Fondos C2C'
};
/**
 * Variable con los posibles valores de los destinos
 */

exports.DESTINO_FORM = DESTINO_FORM;
const DESTINO = {
  AVATAR: 'Avatar',
  INSIDESALES: 'InsideSales',
  GEVICO: 'Gevico',
  FONDOS: 'Fondos'
};
/**
 * Variable con los posibles valores de encaminamiento
 */

exports.DESTINO = DESTINO;
const TIPOS_ENCAMINAMIENTO = {
  SVC_A: 'SVC_A',
  SVC_B: 'SVC_B',
  SVC_C: 'SVC_C',
  ME_A: 'ME_A',
  ME_B: 'ME_B',
  ME_C: 'ME_C',
  FONINS_A: 'FONINS_A',
  FONINS_B: 'FONINS_B',
  FONINS_C: 'FONINS_C',
  FONINS_D: 'FONINS_D',
  FONINS_E: 'FONINS_E',
  FONGEV_A: 'FONGEV_A',
  FONGEV_B: 'FONGEV_B',
  FONGEV_C: 'FONGEV_C',
  FONGEV_D: 'FONGEV_D',
  FONGEV_E: 'FONGEV_E'
};
/**
 * Variable con los posibles valores de TES
 */

exports.TIPOS_ENCAMINAMIENTO = TIPOS_ENCAMINAMIENTO;
const TESVALUES = {
  SI: 'SI',
  NO: 'NO'
};
exports.TESVALUES = TESVALUES;
const phoneProps = {
  color: 'white',
  segment: 'emp',
  kind: 'telefono',
  view: 'phoneNumber',
  applySam: true,
  samActions: {
    900: 'show'
  },
  print900: true,
  textProps: {
    className: 'ContactBar__call--text',
    align: 'left',
    kind: 'span',
    size: 'title05',
    fontType: 'font-bold',
    tabletProps: {
      size: 'title06'
    }
  },
  textPhoneNumberProps: {
    className: 'ContactBar__call--text',
    align: 'left',
    kind: 'span',
    size: 'title05',
    fontType: 'font-bold',
    tabletProps: {
      size: 'title06'
    }
  }
};
/**
 * Especificaciones de mensajes y funcionalidad de los modales
 */

exports.phoneProps = phoneProps;
const MODAL_CONTENT = {
  c2c: {
    title_emp: 'Contacta con un experto',
    content_emp: 'Déjanos tus datos y uno de nuestros expertos contactará contigo para resolver dudas o ayudarte con lo que necesites.',
    horario_emp: 'Horario de atención: 9:00-19:00'
  },
  callNotStablished: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Lo sentimos, no hemos podido registrar su solicitud. Inténtelo de nuevo.'
  },
  callPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Muchas gracias por su interés, le llamará nuestro próximo agente disponible'
  },
  requestPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Espere unos instantes, estamos procesando su solicitud.'
  },
  cmlPending: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Muchas gracias por su interés, le llamaremos en el horario que nos ha indicado.'
  },
  invalidForm: {
    title_emp: 'Servicio de Atención Online',
    content_emp: 'Rellene los campos correctamente'
  }
};
/**
 * Se crea el objeto de contexto, cuando no se puede acceder desde redux
 * @param {string} segment  segmento
 * @returns {object} Devuelve la informacion de contexto construida
 */

exports.MODAL_CONTENT = MODAL_CONTENT;

const _createSondaContext = segment => {
  let clientIDs = null;

  if (window.IC && window.IC.getClientIds) {
    clientIDs = window.IC.getClientIds();
  }

  const context = {
    pageSegment: segment || '',
    contextURL: window.location.href || '',
    clientIDs
  };
  return context;
};
/**
 * Envia la información del formulario a BI
 * @param {object} data Informacion del formulario
 * @returns {boolean} Devuelve true si no dio error js el envio, false si dio error js
 */


exports._createSondaContext = _createSondaContext;

const _envioBI = (data, destino, contextEmp, fixedCampaign) => {
  const sonda = new _gerenciatdUtils.default({
    processName: 'envioBI',
    context: contextEmp,
    filePath: 'emp/c2c'
  });

  try {
    const {
      name,
      phone,
      cif,
      provincia
    } = data;
    const iframeForm = document.getElementById('iframeInsideBI');
    const consDate = Date.now();
    let campaign = '';

    try {
      if (fixedCampaign == '') {
        campaign = window.SCX.getCurrentInfo().SCX_CAMPAIGN.SCX_CAMPAIGN_VALUE;
      } else {
        campaign = fixedCampaign;
      }
    } catch (error) {
      sonda.warningMessage({
        error,
        info: 'Campaña no fue posible de encontrar en envio BI'
      });
      campaign = 'No asignada';
    }

    iframeForm.contentWindow.consData.setnSend(name, phone, 'C2C@insideSales.com', 'N/A', cif, provincia, 'N/A', consDate, campaign, destino);
    return true;
  } catch (error) {
    sonda.errorMessage({
      error,
      info: 'Envio a BI erroneo'
    });
    return false;
  }
};
/**
 * Envia la información del formulario a SE
 * @param {object} data Informacion del formulario
 * @returns {boolean} Devuelve true si no dio error js el envio, false si dio error js
 */


exports._envioBI = _envioBI;

const _envioSE = (data, destino, tipo, tes, contextEmp, fixedCampaign, fixedProduct) => {
  const sonda = new _gerenciatdUtils.default({
    processName: 'envioSE',
    context: contextEmp,
    filePath: 'emp/c2c'
  });

  try {
    const {
      name,
      phone,
      cif,
      date,
      time,
      provincia,
      empleados
    } = data;
    const iframeForm = document.getElementById('iframeInsideSE');
    let campaign = '';
    let product = '';

    try {
      if (fixedCampaign == '') {
        campaign = window.SCX.getCurrentInfo().SCX_CAMPAIGN.SCX_CAMPAIGN_VALUE;
      } else {
        campaign = fixedCampaign;
      }
    } catch (error) {
      sonda.warningMessage({
        error,
        info: 'Campaña no fue posible de encontrar en envio SE'
      });
      campaign = 'No asignada';
    }

    try {
      if (fixedProduct == '') {
        if (window.s && window.s.products && window.s.products != '') {
          product = window.s.products;
        } else {
          product = window.location.pathname;
        }
      } else {
        product = fixedProduct;
      }
    } catch (error) {
      sonda.warningMessage({
        error,
        info: 'Producto no fue posible de asignar en envio SE'
      });
      product = window.location.pathname;
    }

    iframeForm.contentWindow.consData.setnSend(date, time, product, campaign, destino, tes, tipo, cif, provincia, 'N/A', 'N/A', 'N/A', phone, 'N/A', name, empleados);
    return true;
  } catch (error) {
    sonda.severalMessage({
      error,
      info: 'Envio a SE erroneo'
    });
    return false;
  }
};
/**
 * Comprueba si estamos en horario de atencion valido
 * @returns {boolean} True si estamos dentro de horario, false si no
 */


exports._envioSE = _envioSE;

const _CMNTimeTableValid = () => {
  try {
    const date = new Date();
    const hour = date.getHours();

    if (hour >= 9 && hour < 19) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};

exports._CMNTimeTableValid = _CMNTimeTableValid;

const printPrivacyPolicy = () => {
  {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "modal_wrapper-legal-content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Informaci\xF3n sobre Privacidad",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.BLACK,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.BOLD,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Movistar informa que los datos que se facilitan en el presente formulario ser\xE1n tratados por Telef\xF3nica de Espa\xF1a S.A.U. y Telef\xF3nica M\xF3viles Espa\xF1a S.A.U. (en adelante Movistar) como corresponsables con la finalidad de proporcionarle la informaci\xF3n comercial solicitada, as\xED como el resto de finalidades que se hubieran permitido o autorizado de conformidad con lo dispuesto en la <a target=\"_blank\" href=\"/privacidad\">Pol\xEDtica de Privacidad.</a>",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Movistar informa que dispondr\xE1 de los siguientes medios para ejercer sus derechos:",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "\xB7 Si usted ya es Cliente, dirigiendo un escrito Referencia DATOS a la direcci\xF3n de correo electr\xF3nico  <a href=\"mailto:TE_datos@telefonica.com\">TE_datos@telefonica.com</a>; dirigiendo un escrito al Apartado de Correos 46155, 28080 Madrid; o a trav\xE9s del tel\xE9fono gratuito 224407 desde cada una de sus l\xEDneas fijas o m\xF3viles.",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "\xB7 Si usted no es Cliente Movistar, podr\xE1 ponerse en contacto a trav\xE9s de la siguiente direcci\xF3n de correo electr\xF3nico <a href=\"mailto:arcopcl@telefonica.com\">arcopcl@telefonica.com</a>, o llamando al n\xFAmero 900 10 50 92.",
        align: _gerenciatdUnifiedcomponents.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents.COLOR.GREY_7,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        segment: _gerenciatdUnifiedcomponents.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents.DISPLAY.BLOCK
      })]
    });
  }
};

exports.printPrivacyPolicy = printPrivacyPolicy;

const printIframes = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: "div_contenedor_iframe",
    className: "oculto",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      width: "100%",
      title: "iframeSE",
      id: "iframeInsideSE",
      scrolling: "no",
      src: "/empresas/C2CInsideSales"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      width: "100%",
      title: "IframeBI",
      id: "iframeInsideBI",
      scrolling: "no",
      src: "/empresas/formularioIframe"
    })]
  });
};

exports.printIframes = printIframes;

const printCheckBoxs = taggingInfo => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
      name: "checkCliente",
      label: "Ya soy cliente Movistar",
      value: "cliente",
      taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentContent: 'checkbox-checkCliente'
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
      name: "checkNoClienteRemarketing",
      label: "No soy cliente Movistar y me gustar\xEDa estar al d\xEDa de novedades y promociones a trav\xE9s de medios electr\xF3nicos",
      value: "noClienteRemarketing",
      taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentContent: 'checkbox-checkNoClienteRemarketing'
      })
    })]
  });
};

exports.printCheckBoxs = printCheckBoxs;

//# sourceMappingURL=functionsUtils.js.map